import { R } from '@leverege/value-resolver';
import { businessStates } from '../../../constants';
import AliasEqualsSelector from '../AliasEqualsSelector';
import BusinessStateEqualsComparator from './BusinessStateEqualsComparator';
const options = Object.entries(R(businessStates)).map(([key, value]) => {
  return {
    name: value,
    value: key
  };
});
export default AliasEqualsSelector.create(BusinessStateEqualsComparator, options);